<template>
    <!-- <div class="the-select">
        <div class="row mb-2">
            <label v-if="title && title.trim().length > 0" for="" class="col-12 col-form-label text-sm" style="">
                {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
            </label>
            <div class="col-12">
                <select ref="select" class="form-control select2bs4" :disabled="isReadOnly || false" :multiple="isMultiple || false" style="width: 100%">
                    <option v-for="item in options" :value="item.id" :key="item.id">{{ item.name }} </option> 
                </select>
            </div>
        </div>
        <div class="text-danger text-right mb-2" style="margin-top: -13 !important;" v-if="error">
            {{ error }}
        </div>
    </div> -->
    <div class="form-group row">
        <label v-if="title && title.trim().length > 0" class="col-sm-4 col-form-label">
                {{ title }} <span class="text-danger">{{ isRequire ? '(*)' : '' }}</span>
        </label>
        <div class="col-sm-8">
        <select ref="select" class="form-control" :disabled="isReadOnly || false" :multiple="isMultiple || false" style="width: 100%">
            <option value=""></option>
            <option v-for="item in options" :value="item.id" :key="item.id">{{ item.name }} </option> 
        </select>
        <div class="text-danger text-right mb-2" v-if="error">
            {{ error }}
        </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { ref, toRefs } from "vue";
export default {
    props: {
        id: String,
        title: String,
        placeholder: String,
        options: Array,
        error: String,
        isMultiple: Boolean,
        isReadOnly: Boolean,
        isRequire: Boolean,
        isAllowClear: Boolean,
        initialValue: String,
        dropdownParent: String
    },
    setup(props) {
        // let model = ref("")
        // let { initialValue } = toRefs(props)
        // model.value = initialValue.value
        // return { model };
    },
    methods: {
        // async changeValue(value) {
        //     $(this.$refs.select).val(value).trigger('change');
        // }
    },
    watch: {
        error() {
            if(this.error) {
                $(this.$refs.select).addClass('is-invalid');
            } else {
                $(this.$refs.select).removeClass('is-invalid');
            }
        }
    },
    mounted() {
        let self = this;
        let selectElement = $(this.$refs.select);
        selectElement.select2({
            language: {
                noResults: function() {
                    return "Không có dữ liệu";
                }
            },
            placeholder: 'Chọn ' + this.title,
            theme: "bootstrap4",
            allowClear: this.isAllowClear,
            //selectOnClose: true,            
            //closeOnSelect: true,
            dropdownParent: this.dropdownParent ? $('#'+ this.dropdownParent): null
        })
        .val(this.initialValue)
        .trigger('change')
        .on('change', function() {
             self.$emit('onChange', $(this).val());
        });
    }
}
</script>
<style>
</style>